import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TsButtonComponent } from './ts-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { TSIconModule } from '../ts-icon/ts-icon.module';
import { TSDebounceClickDirective } from '../directives/debounce-click.directive';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LucideAngularModule } from 'lucide-angular';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    TSIconModule,
    MatProgressSpinnerModule,
    MatButtonToggleModule,
    MatMenuModule,
    OverlayModule,
    MatTooltipModule,
    LucideAngularModule,
  ],
  declarations: [TsButtonComponent, TSDebounceClickDirective],
  exports: [TsButtonComponent],
})
export class TsButtonModule {}
